/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {SurveyStatus} from "@app/app-shared/metro";

export const demoHraSurveyStatuses: SurveyStatus[] = [
    {
        anniversary: "03/15/2025",
        year: "2025",
        startedDate: "11/15/2024",
        status: "31",
        completedDate: "12/10/2024",
        answersJson: {},
        deactivated: false,
    },
    {
        anniversary: "03/15/2025",
        year: "2024",
        startedDate: "11/15/2023",
        status: "18",
        completedDate: undefined,
        answersJson: {},
        deactivated: false,
    },
    {
        anniversary: "03/15/2025",
        year: "2023",
        startedDate: "--/--/----",
        status: "0",
        completedDate: undefined,
        answersJson: {},
        deactivated: true,
    },
];

export const demoChapsSurveyStatuses: SurveyStatus[] = [
    {
        anniversary: "03/15/2025",
        year: "2025",
        startedDate: "11/20/2024",
        status: "20",
        completedDate: "12/05/2024",
        answersJson: {},
        deactivated: false,
    },
    {
        anniversary: "03/15/2025",
        year: "2024",
        startedDate: "11/20/2023",
        status: "7",
        completedDate: undefined,
        answersJson: {},
        deactivated: false,
    },
    {
        anniversary: "03/15/2025",
        year: "2023",
        startedDate: "--/--/----",
        status: "0",
        completedDate: undefined,
        answersJson: {},
        deactivated: false,
    },
];